<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">

                        <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->

                            <div class="chat-web-section chat-user-list-main float-l width-full"> <!--web view-->
                                <h2 class="chat-page-title float-l width-full color-333333 heading-text-24 line-height-28 font-bold ucase pb_5"> Customer List </h2>

                                <div class="user-listing-section-web customer-listing-section-web float-l width-full">

                                    <vue-good-table
                                            ref="listUserList"
                                            mode="remote"
                                            title="Customer"
                                            @on-page-change="onPageChange"
                                            @on-selected-rows-change="selectionChanged"
                                            @on-column-filter="onColumnFilter"
                                            @on-per-page-change="onPerPageChange"
                                            @on-sort-change="onSortChange"
                                            :totalRows="totalRecords"
                                            :columns="columns"
                                            :rows="rows"
                                            :pagination-options="{
                                                enabled: true,
                                                position: 'bottom',
                                                perPage: 10,
                                                dropdownAllowAll: false,
                                            }"
                                            :search-options="{
                                                enabled: false,
                                            }">
                                    </vue-good-table>
                                </div>

                            </div> <!--web view-->

                            <div class="user-list-mobile float-l width-full"> <!--mobile view-->
                                <div class="add-user-form col-12 float-l mt_10">
                                    <div class="form-group float-l width-full pt_15 pl_15 pr_15 pb_0">
                                        <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Section </p>
                                        <!-- <select name="cars" class="custom-select">
                                            <option selected>All</option>
                                            <option value="volvo">Rental</option>
                                            <option value="fiat">Punjabi</option>
                                            <option value="audi">VTC</option>
                                        </select>
                                        <span> <i class="fa fa-angle-down"></i> </span> -->
                                        
                                        <v-select v-model="sectionId" name="timezoneId" placeholder="Select Section."
                                                label="text"
                                                :options="sectionArr">
                                        </v-select>
                                        
                                    </div>
                                </div> 

                                <template v-if="customerArray && customerArray.length > 0">
                                    <div class="customer-list-main col-12 float-l" v-for="customer in customerArray">

                                        <div class="internal-customer-list float-l width-full">
                                            <h4 class="heading-text-16 line-height-20 color-333333 font-benton-medium float-l width-full mb_6"> {{customer.name}} </h4>
                                            <p class="heading-text-14 line-height-18 color-888888 font-text-regular-benton float-l width-full mb_0"> {{customer.email}} </p>
                                            <router-link title="View User" v-bind:to="{name: 'CustomerDetails', params:{id: customer.id}}"><i class="fa fa-angle-right"></i></router-link>               
                                        </div>
                                    </div>
                                </template>
                            </div> <!--mobile view-->
                        </div> <!--middle section-->	 

                    </div>
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
        <!--middle middle section-->
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);
    var contex;
    Vue.component("app-footer", Footer);
    export default {
        name: 'CustomerList',
        mixins: [commonMixins],
        data () {
            return {
                sectionId: {
                    text: 'All',
                    value: 0
                },
                sectionArr: [],
                cantAccessPage: true,
                isRequestComplete: false,
                columns: [
                    {
                        label: 'Username',
                        field: 'name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Phone',
                        field: 'phone',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Phone", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created At", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Section',
                        field: 'sections',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Section", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            // filterDropdownItems: ['Rental', 'Punjabi', 'Velocitytruckcenter'],
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                        
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 10
                },
                customerArray: [],
                firstLoad: 0,
                mobileView: false
            }
        },
        watch: {
            sectionId: function(sectionId) {
                contex.loadCustomer();
            }
        },
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
            var self = this;
            self.loadCustomer();
            EventBus.$emit("headerMobileView", 'Customer List');
            self.getPermissions();
            self.loadSection();

           self.mobileResizeViewCustomerListPage();
            window.onresize = function() {
                self.mobileResizeViewCustomerListPage();
            }
        },
        methods: {
            mobileResizeViewCustomerListPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.mobileView = true;
                } else {
                    self.mobileView = false;
                    self.loadCustomer();
                }
            },
            loadSection: function() {
                var self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-sections", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                var tempArr = data.data.content;
                                var arr = {};
                                arr = tempArr[0];
                                tempArr[0] = {value:0, text:'All'};
                                tempArr[tempArr.length] = arr;
                                self.sectionArr = tempArr;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadCustomer();
            },
            onPerPageChange(params) {
                this.serverParams.page = 1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadCustomer();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('email');
                    field:('phone');
                    field:('created_at');
                    field:('section');

                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1) {
                    this.loadCustomer();
                }
            },
            selectionChanged() {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadCustomer();
            },
            /* viewCustomerPage: function(params) {
                @on-row-click="viewCustomerPage"
                var self = this;
                self.$router.push("/customer/detail/" + params.row.id);
            }, */
            loadCustomer: function() {
                var self = this;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    isCustomerList: 'customerList',
                    sectionSearchValue: self.mobileView ? {text: self.sectionId.text, value: self.sectionId.value} : '',
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                // alert(localStorage.getItem("tkn"));return false;
                self.firstLoad = 1;
                self.showLoader();
                // HTTP.post("list-customer", fields, config)
                HTTP.post("interacted-customers", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {

                            if (response.data.content != "") {
                                //self.customerArray = response.data.content;
                                self.customerArray = response.data.content.row;
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
        }
    }
    EventBus.$on("serachCustomerArrayData", function(data) {
        contex.customerArray = data;
    });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Customer/CustomerList.vue